import { Component, HostListener, inject, OnInit } from '@angular/core';
import { TopicRepository } from '../../../data/topic/topic.repository';
import { BehaviorSubject, firstValueFrom, tap } from 'rxjs';
import { ModalController } from '@ionic/angular';
import { DayService } from '../../../data/day/day.service';
import { exit } from 'ionicons/icons';
import { EventManager } from '@angular/platform-browser';

export interface CursorPosition {
  x: number;
  y: number;
}

enum CursorDirection {
  Up,
  Down,
  Left,
  Right
}

@Component({
  selector: 'app-min-writer-menu',
  templateUrl: './min-writer-menu.component.html',
  styleUrls: ['./min-writer-menu.component.scss']
})
export class MinWriterMenuComponent implements OnInit {
  modalController = inject(ModalController);
  topicRepository = inject(TopicRepository);

  dayService!: DayService

  // trackerVms$ = this.dayService.trackerVms$
  //   .pipe(tap(vms => console.log({vms})));

  private lastCursorPosition?: CursorPosition;
  cursorPosition$ = new BehaviorSubject<CursorPosition>({x: 0, y: 0});

  lastKey = ''

  private eventManager = inject(EventManager);

  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // console.log(event.key);
    this.lastKey = event.key
    switch (event.key) {
      case 'w':
        this.moveCursor(CursorDirection.Up)
        break;
      case 's':
        this.moveCursor(CursorDirection.Down)
        break;
      case 'a':
        this.moveCursor(CursorDirection.Left)
        break;
      case 'd':
        this.moveCursor(CursorDirection.Right)
        break;
      case 'Enter':
        this.select();
    }
  }

  constructor() {
    addEventListener('keydown', (ev) => this.lastKey = ev.key);
  }

  ngOnInit() {
    if (this.lastCursorPosition) {
      this.cursorPosition$.next(this.lastCursorPosition);
    }
  }

  async moveCursor(direction: CursorDirection) {
    const index = await firstValueFrom(this.dayService.index$);
    let {x, y} = this.cursorPosition$.value;

    if (direction === CursorDirection.Up) {
      if (y > 0) {
        y = y - 1;
      } else {
        y = index[x].vms.length - 1;
      }
    }

    if (direction === CursorDirection.Down) {
      if (y < index[x].vms.length - 1) {
        y = y + 1;
      } else {
        y = 0
      }
    }


    if (direction === CursorDirection.Left) {
      if (x > 0) {
        x = x - 1;
      } else {
        x = index.length - 1
      }

      while (index[x].vms.length === 0) {
        if (x > 0) {
          x = x - 1;
        } else {
          x = index.length - 1;
        }
      }
    }

    if (direction === CursorDirection.Right) {
      if (x < index.length - 1) {
        x = x + 1;
      } else {
        x = 0
      }

      while (index[x].vms.length === 0) {
        if (index.length - 1 > x) {
          x = x + 1;
        } else {
          x = 0;
        }
      }
    }

    if (index[x].vms.length - 1 < y) {
      y = index[x].vms.length - 1;
    }

    this.cursorPosition$.next({x, y});
  }

  async select() {
    const index = await firstValueFrom(this.dayService.index$);
    const {x, y} = this.cursorPosition$.value;
    this.modalController.dismiss({
      vm: index[x].vms[y],
      cursorPosition: {x, y}
    }, 'select')
  }

  exit() {
    this.modalController.dismiss(null, 'exit');
  }
}
